// Icona domicilio: versione SVG fornita (ciclista stilizzato)
export default function Delivery(props) {
	return (
		<svg
			viewBox="0 0 398.55 342.19"
			width="1em"
			height="1em"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			{...props}
		>
			<path d="M317.31,125.1v33c-22.46.78-45.73-5.76-64.53-17.97-12.54-8.15-22.43-19.42-33.83-28.96l-38.57,38.56c-.46,2.61,32.11,33.87,35.93,38.86v103.5h-34v-83.5c-15.09-14.75-32.74-27.57-48.01-41.99-17.01-16.06-21.81-31.97-5.5-51.53,10.82-12.97,36.01-38.34,48.99-49.01,33.21-27.3,60.96,17.85,82.51,36.54,16.17,14.03,35.36,22.04,57.01,22.49Z" />
			<path d="M307.11,175.4c114.94-10.8,124.5,162.65,11.69,166.69-106.66,3.81-116.85-156.8-11.69-166.69ZM310.1,200.39c-23.15,2.21-44.86,21.15-50.29,43.71-14.68,61.03,63.25,99.1,101.91,49.91,31.82-40.48-1.81-98.37-51.62-93.62Z" />
			<path d="M74.11,175.4c114.06-10.71,124.54,161.72,11.69,166.69-106.38,4.69-117.9-156.71-11.69-166.69ZM77.1,200.39c-72.15,6.8-67.7,116.3,5.88,116.33,79.01.03,73.85-123.84-5.88-116.33Z" />
			<path d="M253.07.36c40.08-5.46,53.13,52.84,14.8,64.8-46.22,14.41-61.71-58.41-14.8-64.8Z" />
		</svg>
	);
}
